import dayjs from 'dayjs'
import cache from '@fe/zxwy-utils/utils/cache'

export {
  cache
}

export default {
  install(app) {
    app.config.globalProperties.$dayjs = dayjs
    app.config.globalProperties.$cache = cache
  }
}